import { useQuery } from '@apollo/client';
import _orderBy from 'lodash/orderBy';

import { gql } from 'src/__generated__';
import { useJobId } from 'src/context/useJobId';

const DOCUMENTS_QUERY = gql(`
  query DocumentsQuery($jobId: ID!) {
    viewer {
      _id
      resumes {
        ...resume
      }
    }
    jobApplicationProcess(jobId: $jobId) {
      documents {
        lastAppliedResumeIdPrefill
        selectionCriteriaRequired
        lastWrittenCoverLetter {
          content
        }
      }
    }
  }
`);

export function useDocuments() {
  const jobId = useJobId();
  const { data, loading, error } = useQuery(DOCUMENTS_QUERY, {
    variables: { jobId },
  });

  const resumes = _orderBy(
    data?.viewer?.resumes || [],
    ['createdDateUtc'],
    ['desc'],
  );

  const resumesMap = new Map(resumes.map((item) => [item.id, item]));
  const defaultId = data?.jobApplicationProcess?.documents
    .lastAppliedResumeIdPrefill as string;
  const defaultResume = resumesMap.get(defaultId);
  const defaultCoverletter =
    data?.jobApplicationProcess?.documents.lastWrittenCoverLetter?.content;

  const shouldRenderselectionCriteria =
    data?.jobApplicationProcess?.documents.selectionCriteriaRequired;

  return {
    resumes,
    defaultResume,
    defaultCoverletter,
    shouldRenderselectionCriteria,
    loading,
    error,
  };
}
